<template>
  <span class="profile-avatar">
    <img :src="displayImage" :style="{height: calSize + 'px', width: calSize + 'px'}" />
  </span>
</template>

<script>
export default {
  props: ["image", "size"],
  computed: {
    displayImage() {
      return this.image || "/img/personHead.png";
    },
    calSize() {
      return this.size || 50;
    }
  }
};
</script>

<style lang="less">
.profile-avatar {
  img {
    border-radius: 50%;
    object-fit: contain;
  }
}
</style>
